export default "__VITE_ASSET__ed842d3e__"